import React from "react"
import "./showStep.scss"

interface showStepInteface {
  pageActual: number,
  nextPage: string;
}

const ShowStep = (props: showStepInteface) => {
  const {pageActual, nextPage} = props
  return (
    <div className="a-showstep">
      <p className="a-showstep__page">{pageActual} de 5</p>
      <span className="a-showstep__bar" />
      <span
        className="a-showstep__bar--progress"
        style={{ width: `${pageActual * 20}%` }}
      />
      <p className="a-showstep__name show-on-mobile">{nextPage}</p>
    </div>
  )
}

export default ShowStep
